<template>
  <div style="position: relative;">
    <el-form ref="SignRecordFilter" :model="SignRecordList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">

        <el-form-item label="人员名称" prop="formFilter.userName">
          <el-input class="filter-item" v-model="SignRecordList.formFilter.userName"
                    :clearable="true" placeholder="请输入参与人员名称"
          />
        </el-form-item>

        <el-form-item label="部门" prop="formFilter.bumenmingcheng">
          <el-select class="filter-item" v-model="SignRecordList.formFilter.bumenmingcheng" :clearable="true" filterable
            placeholder="选择部门" :loading="SignRecordList.daleimingchengLv.impl.loading"
            @visible-change="SignRecordList.daleimingchengLv.impl.onVisibleChange"
            @change="onAssessLvValueChange">
            <el-option v-for="item in SignRecordList.daleimingchengLv.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>


        <el-form-item label="开始时间" prop="formFilter.language">
          <div class="block">
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="filter-item" v-model="SignRecordList.formFilter.kaishishijian" type="date" placeholder="选择开始日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="结束时间" prop="formFilter.language">
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="filter-item" v-model="SignRecordList.formFilter.jiesushijian" type="date" placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>
        <!-- ziyi 2022年6月11日 end -->
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetUserWorkList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="onExportClick()">导出</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshUserWorkList(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="SignRecordLine" :data="SignRecordList.SignRecordLine.impl.dataList" :size="defaultFormItemSize" @sort-change="SignRecordList.SignRecordLine.impl.onSortChange"
          header-cell-class-name="table-header-gray" height="600px"
          highlight-current-row @current-change="SignRecordList.SignRecordLine.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="SignRecordList.SignRecordLine.impl.getTableIndex" />
          <el-table-column label="员工姓名" prop="userName" width="120px">
          </el-table-column>
          <el-table-column label="考勤日期" prop="attnDate" width="120px">
          </el-table-column>
          <el-table-column label="打卡类型" prop="signType" width="120px">
          </el-table-column>
          <el-table-column label="违规类型" prop="regulationsType" width="120px">
          </el-table-column>
          <el-table-column label="打卡超时(分钟)" prop="signLackHour" width="120px">
          </el-table-column>
          <el-table-column label="打卡时间" prop="signTime" width="120px">
          </el-table-column>
          <el-table-column label="打卡地点" prop="signPosition" width="120px">
          </el-table-column>
          <el-table-column label="打卡经度" prop="signLongitude" width="120px">
          </el-table-column>
          <el-table-column label="打卡纬度" prop="signLatitude" width="120px">
          </el-table-column>
          <el-table-column label="考勤组名称" prop="attnGroupName" width="120px">
          </el-table-column>
          <el-table-column label="是否外勤" prop="attnAnywhereFlag" width="120px">
          </el-table-column>
          <el-table-column label="来源" prop="signSource" width="120px">
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="SignRecordList.SignRecordLine.impl.totalCount"
            :current-page="SignRecordList.SignRecordLine.impl.currentPage"
            :page-size="SignRecordList.SignRecordLine.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="SignRecordList.SignRecordLine.impl.onCurrentPageChange"
            @size-change="SignRecordList.SignRecordLine.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import {DictionaryController, PaSignRecordController} from '@/api';

export default {
  name: 'SignRecordList',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      SignRecordList: {
        formFilter: {
          kaishishijian: undefined,
          jiesushijian: undefined,
          bumenmingcheng:undefined,
          userName:undefined
        },
        formFilterCopy: {
          kaishishijian:undefined,
          jiesushijian:undefined,
          bumenmingcheng :undefined,
          userName :undefined
        },
        SignRecordLine: {
          impl: new TableWidget(this.loadPaWorkLineWidgetData, this.loadPaWorkLineVerify, true, true, 'updateTime', 0)
        },
        daleimingchengLv: {
           impl: new DropdownWidget(this.loaddaleimingchengLvDropdownList)
        },

        languageLv: [{
             value: 'wait_approval',
             label: '待审批'
           }, {
             value: 'completed',
             label: '已完成'
        }],

        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetUserWorkList () {
      this.$refs.SignRecordFilter.resetFields();
      this.refreshUserWorkList(true);
    },
    /**
     * 作品行数据获取函数，返回Promise
     */
    loadPaWorkLineWidgetData (params) {
      if (params == null) params = {};
      if (this.SignRecordList.formFilterCopy.kaishishijian && this.SignRecordList.formFilterCopy.jiesushijian) {
        if (new Date(this.SignRecordList.formFilterCopy.kaishishijian).getTime() > new Date(this.SignRecordList.formFilterCopy.jiesushijian).getTime()) {
          this.$message.error('操作失败!开始时间 不能大于 结束时间!');
          return;
        }
      }

      params = {
        ...params,
        paSignRecordDtoFilter: {
          kaishishijian:this.SignRecordList.formFilterCopy.kaishishijian,
          jiesushijian:this.SignRecordList.formFilterCopy.jiesushijian,
          deptId:this.SignRecordList.formFilterCopy.bumenmingcheng,
          userName:this.SignRecordList.formFilterCopy.userName
        }
      }
      return new Promise((resolve, reject) => {
        PaSignRecordController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.SignRecordList.SignRecordLine.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.SignRecordList.SignRecordLine.impl.currentRow.id, 'id');
              this.$refs.SignRecordLine.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品行数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaWorkLineVerify () {
      this.SignRecordList.formFilterCopy.kaishishijian = this.SignRecordList.formFilter.kaishishijian;
      this.SignRecordList.formFilterCopy.jiesushijian = this.SignRecordList.formFilter.jiesushijian;
      this.SignRecordList.formFilterCopy.bumenmingcheng = this.SignRecordList.formFilter.bumenmingcheng;
      this.SignRecordList.formFilterCopy.userName = this.SignRecordList.formFilter.userName;
      return true;
    },

    //部门名称下拉选择器
    loaddaleimingchengLvDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDictDaLeiMingCheng(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },

    /**
     * 作品评级选中值改变
     */
    onAssessLvValueChange (value) {
      console.log("value-->" + value)
    },
    /**
     * 更新人员作品列表
     */
    refreshUserWorkList (reloadData = false) {
      if (reloadData) {
        this.SignRecordList.SignRecordLine.impl.refreshTable(true, 1);
      } else {
        this.SignRecordList.SignRecordLine.impl.refreshTable();
      }
      if (!this.SignRecordList.isInit) {
        // 初始化下拉数据
      }
      this.SignRecordList.isInit = true;
    },
    /**
     * 导出
     */
    onExportClick () {
      this.loadPaWorkLineVerify();
      let params = {};
      if (this.SignRecordList.formFilterCopy.kaishishijian && this.SignRecordList.formFilterCopy.jiesushijian) {
        if (new Date(this.SignRecordList.formFilterCopy.kaishishijian).getTime() > new Date(this.SignRecordList.formFilterCopy.jiesushijian).getTime()) {
          this.$message.error('操作失败!开始时间 不能大于 结束时间!');
          return;
        }
      }
      params = {
        paSignRecordDtoFilter: {
          kaishishijian:this.SignRecordList.formFilterCopy.kaishishijian,
          jiesushijian:this.SignRecordList.formFilterCopy.jiesushijian,
          deptId:this.SignRecordList.formFilterCopy.bumenmingcheng,
          userName:this.SignRecordList.formFilterCopy.userName
        }
        //, ...params
      }
      PaSignRecordController.export(this, params, '打卡明细.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    onResume () {
      this.refreshUserWorkList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshUserWorkList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
